/**
 * Funnel Event Tracker
 * Tracks funnel events to analytics_events for buyer insights
 */

import { backgroundJobs } from './backgroundJobs';
import { userAuth } from './userAuth';

const getUserId = (): string => {
  const user = userAuth.getCurrentUser();
  return user && !user.isGuest ? user.id : 'anonymous';
};

export const funnelEventTracker = {
  track(eventType: string, eventData?: Record<string, unknown>): void {
    const userId = getUserId();
    backgroundJobs.trackEvent(userId, eventType, eventData || {});
  },

  aiExam1Completed(score: number, passed: boolean): void {
    this.track('funnel_ai_exam_1_completed', { score, passed });
  },

  aiExam2Completed(score: number, passed: boolean): void {
    this.track('funnel_ai_exam_2_completed', { score, passed });
  },

  signupGateShown(source: 'ai_exam_1_results'): void {
    this.track('funnel_signup_gate_shown', { source });
  },

  signupGatePassed(): void {
    this.track('funnel_signup_gate_passed', {});
  },

  subscriptionGateShown(source: 'ai_exam_2_results'): void {
    this.track('funnel_subscription_gate_shown', { source });
  },

  subscriptionGatePassed(): void {
    this.track('funnel_subscription_gate_passed', {});
  },
};
